import { InjectionToken } from '@angular/core';
export const MATHJAX_CONFIG = new InjectionToken('MathJaxConfig');
/**
 * @deprecated just provide window at app root
 * `{ provide: Window, useValue: window }`
 */
export const WindowToken = new InjectionToken('Window');
export function windowProvider() {
    return window;
}
